const acceptCookies = version => ({
  type: 'ACCEPT_COOKIES',
  version,
});

export default acceptCookies;
